import { render, staticRenderFns } from "./BrowsTemplatesArticle.vue?vue&type=template&id=84da6714&scoped=true&"
import script from "./BrowsTemplatesArticle.vue?vue&type=script&lang=js&"
export * from "./BrowsTemplatesArticle.vue?vue&type=script&lang=js&"
import style0 from "./BrowsTemplatesArticle.vue?vue&type=style&index=0&id=84da6714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84da6714",
  null
  
)

export default component.exports